import "lazysizes";
import data from "data/TechStack";

export default function TechStack() {
  return (
    <div className="max-w-3xl mx-auto px-4">
      {" "}
      <h3 className="font-bold text-lg sm:text-xl mb-6 dark:text-white">
        Tech Stack
      </h3>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-1 sm:gap-5">
        {data.map(({ title, tech }, i) => (
          <div key={i}>
            <h5 className="font-medium mb-5 text-subText mt-5 dark:text-dark_text">
              {title}
            </h5>

            <ul>
              {tech.map((tech, index) => (
                <li
                  key={index}
                  className="flex items-center mb-3 text-base dark:text-white"
                >
                  <img
                    className="lazyload w-5 h-5 mr-2"
                    data-src={tech.icon}
                    alt="javascript"
                  />{" "}
                  {tech.name}{" "}
                  <span className="text-xs font-medium ml-2 opacity-70">
                    {tech.level}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <hr className="mt-5" style={{ color: "#f1f1f1" }} />
    </div>
  );
}
